import { render, staticRenderFns } from "./notificationSystem.vue?vue&type=template&id=68a1c7a1&scoped=true"
import script from "./notificationSystem.vue?vue&type=script&lang=js"
export * from "./notificationSystem.vue?vue&type=script&lang=js"
import style0 from "./notificationSystem.vue?vue&type=style&index=0&id=68a1c7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1c7a1",
  null
  
)

export default component.exports